import { useState } from 'react';
import { Button } from '@/components/ui/Button';

interface Step2Props {
  onNext: (data: Step2Data) => void;
  onBack: () => void;
  initialData?: Step2Data;
}

export interface Step2Data {
  description: string;
}

export const Step2Description = ({ onNext, onBack, initialData }: Step2Props) => {
  const [description, setDescription] = useState(initialData?.description || '');

  const handleSubmit = () => {
    if (description.length >= 500) {
      onNext({ description });
    }
  };

  const remainingChars = 500 - description.length;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Describe your project</h2>
        <p className="text-gray-600 mt-2">
          Tell us what you need in detail. The more information you provide, the more accurate our quote will be.
        </p>
      </div>

      <div>
        <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2">
          Project Description *
        </label>
        <textarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={10}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Example: I need a booking system for my salon business. Customers should be able to view available time slots, book appointments, receive email confirmations, and get SMS reminders. I also need an admin panel where staff can manage bookings, customer profiles, and services offered..."
        />
        <div className="flex justify-between items-center mt-2">
          <p className="text-sm text-gray-500">Minimum 500 characters</p>
          <p
            className={`text-sm ${
              remainingChars > 0 ? 'text-orange-600' : 'text-green-600'
            }`}
          >
            {remainingChars > 0 ? `${remainingChars} characters remaining` : '✓ Minimum met'}
          </p>
        </div>
      </div>

      <div className="flex justify-between">
        <Button onClick={onBack} variant="outline" className="px-8">
          Back
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={description.length < 500}
          className="bg-blue-600 hover:bg-blue-700 text-white px-8"
        >
          Next
        </Button>
      </div>
    </div>
  );
};
